import { useToast } from '@givebutter/primitives/toast';
import { faEnvelope, faLink, faPhone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as DropdownMenu from 'components/dropdown-menu';
import { useCopy } from 'components/snippet';
import { Contact, PledgeActivityResource } from 'types/domain';

interface PledgeActionsProps {
    pledge: PledgeActivityResource['pledge'];
    contact: Contact | null;
}

const PledgeActions = ({ pledge, contact }: PledgeActionsProps) => {
    const toast = useToast();

    const { onClickCopy } = useCopy({
        onCopy: () => {
            toast.success('Copied to clipboard');
        },
    });

    return (
        <DropdownMenu.Root>
            <DropdownMenu.EllipsisTrigger
                className="ml-auto w-5 text-center"
                onClick={event => event.stopPropagation()}
                aria-label="Actions"
            />
            <DropdownMenu.Content onClick={e => e.stopPropagation()}>
                {contact?.primary_email && (
                    <DropdownMenu.Item>
                        <a
                            className="flex gap-2 text-black hover:text-black"
                            href={`mailto:${contact?.primary_email}`}
                        >
                            <FontAwesomeIcon icon={faEnvelope} />
                            Email
                        </a>
                    </DropdownMenu.Item>
                )}
                {contact?.primary_phone && (
                    <DropdownMenu.Item>
                        <a
                            className="flex gap-2 text-black hover:text-black"
                            href={`tel:${contact?.primary_phone}`}
                        >
                            <FontAwesomeIcon icon={faPhone} />
                            Call
                        </a>
                    </DropdownMenu.Item>
                )}
                <DropdownMenu.Item
                    onClick={e => onClickCopy(e, pledge.pay_url)}
                    className="flex gap-2"
                >
                    <FontAwesomeIcon icon={faLink} />
                    Copy payment link
                </DropdownMenu.Item>
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
};

export { PledgeActions };
